import { FC } from "react";
import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";

const Container = styled.div`
  border-radius: 10px;
  padding: 12px;
  background-color: #000;
  opacity: 0.8;
  color: #fff;
  text-align: center;
  font-size: 24px;
  line-height: 36px;
  font-weight: 400;
  overflow: auto;

  @media (max-width: ${ScreenSize.md}px) {
    font-size: 16px;
    line-height: 24px;
  }

  @media (orientation: landscape) {
    @media (max-height: ${ScreenSize.md}px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

const Subtitles: FC<{ text: string }> = ({ text }) => {
  return <Container>{text}</Container>;
};

export default Subtitles;
